import React from "react";

// WP2 — Studio G4 is now the primary brand for admin + portal + public-ops.
// LRS logos remain on disk and are explicitly requested by the LRS public
// pages (Header.jsx, Footer.jsx) via `brand="lrs"` until WPCU, after which
// the LRS public pages are removed from this pod entirely.
// Asset filenames preserve the user-supplied convention and are
// URL-encoded here (`%20` for spaces).
const SG4_LOGO_DARK_SURFACE  = "/SG4_Logo_Light.png";       // light wordmark for dark surfaces
const SG4_LOGO_LIGHT_SURFACE = "/SG4_Logo.png";             // dark wordmark for light surfaces
const LRS_LOGO_DARK_SURFACE  = "/LRS_Logo_Full_Alt_PNG.png";
const LRS_LOGO_LIGHT_SURFACE = "/LRS_Logo_Full_PNG.png";

/**
 * Brand logo — raw <img>, no wrapper / no scrim / no plate.
 * `brand` chooses the asset family (default: Studio G4).
 * `variant` chooses display height.
 *   nav (default) — dark-surface wordmark; h-8 mobile / h-10 desktop
 *   footer        — dark-surface wordmark; h-11
 *   login         — light-surface wordmark; h-14 (light background)
 */
export default function Logo({ variant = "nav", brand = "sg4" }) {
    const isLrs = brand === "lrs";
    const alt = isLrs ? "London Renovation Specialists" : "Studio G4";
    const dark = isLrs ? LRS_LOGO_DARK_SURFACE  : SG4_LOGO_DARK_SURFACE;
    const light = isLrs ? LRS_LOGO_LIGHT_SURFACE : SG4_LOGO_LIGHT_SURFACE;
    const src = variant === "login" ? light : dark;
    const cls =
        variant === "footer" ? "block h-11 w-auto" :
        variant === "login"  ? "block h-14 w-auto mx-auto" :
                               "block h-[38px] md:h-12 w-auto";
    return <img src={src} alt={alt} className={cls}
                data-testid={`${isLrs ? "lrs" : "sg4"}-logo-${variant}`} />;
}
